<template>
  <b-container fluid class="table p-6">
    <b-table hover
             show-empty
             responsive
             id="mytable"
             :items="items"
             :fields="fields"
             empty-text="Нет данных в таблице"
             empty-filtered-text="Нет данных по вашему запросу">

      <template slot="inn_kpp" slot-scope="data">
        <p>{{data.item.inn }}/{{ data.item.kpp}} </p>
      </template>
      <template slot="contact_data" slot-scope="data">
        <p class="mb-0">Контактное лицо:{{data.item.company_profile.contact_person }}</p>
        <p class="mb-0">Город:{{data.item.company_profile.city}}</p>
        <p class="mb-0">Email:{{data.item.company_profile.email }}</p>
        <p class="mb-0">Телефон:{{data.item.company_profile.phones }}</p>
      </template>
      <template slot="ctm_id" slot-scope="data">
        <p>{{data.item.company_profile.ctm_id}}</p>
      </template>
      <template slot="ctm_approve" slot-scope="data">
        <i :class="data.item.company_profile.ctm_approved?'fas fa-check':'fas fa-times'"></i>
      </template>
      <template slot="piportal_registered" slot-scope="data">
        <i :class="data.item.company_profile.piportal_registered?'fas fa-check':'fas fa-times'"></i>
      </template>
      <template slot="actions" slot-scope="data">
        <b-button variant="info" v-b-tooltip.hover title="Клиентская программа"
                  @click="clientProgram(data.item)"><i class="fas fa-address-card"></i></b-button>
      </template>
    </b-table>
    <b-modal id="ModCli"
             ref="modal"
             title="Данные с клиентской программы"
             size="lg">
      <div v-for="ctm in CTMData"
           :key="ctm.ctm_id"
           class="text-center"
      >
        <p>Наименование: {{ctm.name}}</p>
        <p>ИНН: {{ctm.inn}}</p>
        <p>КПП: {{ctm.kpp}}</p>
        <p>СТМ ID: {{ctm.ctm_id}}</p>
        <p>Адрес: {{ctm.address}}</p>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'demo',
  data () {
    return {
      fields: [
        {
          key: 'company_status',
          label: 'Статус',
          thClass: 'status'
        },
        {
          key: 'name',
          label: 'Организация',
          thClass: 'organization'

        },
        {
          key: 'inn_kpp',
          label: 'ИНН / КПП'
        },
        {
          key: 'contact_data',
          label: 'Контактные данные',
          thClass: 'contact_data'
        },
        {
          key: 'ctm_approve',
          label: 'Клиент СТМ',
          thClass: 'ctm'

        },
        {
          key: 'piportal_registered',
          label: 'Fill-Bill аккаунт',
          thClass: 'piportal'

        },
        {
          key: 'actions',
          label: 'Действия'
        }
      ],
      items: null
    }
  },
  watch: {
    companies () {
      this.items = this.companies.filter(function (elm) {
        return elm.company_profile.ctm_approved === false && elm.company_profile.piportal_registered === true
      })
    }
  },
  computed: {
    ...mapState(
      {
        companies: state => state.companies.companies,
        CTMData: state => state.companies.CTMData
      }
    )
  },
  mounted () {
    this.companiesList()
  },
  methods: {
    clientProgram (data) {
      this.getClientProgram(data).then(
        this.$root.$emit('bv::show::modal', 'ModCli', event)
      )
    },
    ...mapActions('companies',
      [
        'companiesList',
        'getClientProgram'
      ]
    )
  }
}
</script>

<style scoped>
  .fa-check {
    color: #40b539;
  }

  .fa-times {
    color: #e7161a;
  }
</style>
